import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 获取FAQ最新消息数量
export const getNewMsgNo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETNEWMSGNO_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getNewMessageNumber, {
            commit
        },
        data,
        type.GETNEWMSGNO_RECEIVE
    )
};

// 获取FAQ 类型数据列表
export const getCategoryList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETCATEGORYLIST_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getCategoryList, {
            commit
        },
        data,
        type.GETCATEGORYLIST_RECEIVE
    )
};

// 获取 FAQ 内容数据列表
export const getFAQContentList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETFAQCONTENTLIST_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getFAQContentList, {
            commit
        },
        data,
        type.GETFAQCONTENTLIST_RECEIVE
    )
};

// 获取 FAQ 内容数据
export const getFAQContentInfo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETFAQCONTENTINFO_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getFAQContentInfo, {
            commit
        },
        data,
        type.GETFAQCONTENTINFO_RECEIVE
    )
};

// 提交客服问题
export const submitQu = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SUBMITQUESTION_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.submitQuestion, {
            commit
        },
        data,
        type.SUBMITQUESTION_RECEIVE
    )
};

// 提交文本类型客服消息
export const submitQuMsgText = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SUBMITQUMSGTEXT_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.submitQuestionMessagesText, {
            commit
        },
        data,
        type.SUBMITQUMSGTEXT_RECEIVE
    )
};

// 提交图片附件类型客服消息
export const submitQuMsgAttr = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SUBMITQUMSGATTR_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.submitQuestionMessagesAttr, {
            commit
        },
        data,
        type.SUBMITQUMSGATTR_RECEIVE
    )
};

// 获取用户历史客服问题列表数据
export const getHstQuList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETHSTQULIST_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getHistoryQuestionList, {
            commit
        },
        data,
        type.GETHSTQULIST_RECEIVE
    )
};

// 获取客服问题历史消息列表数据
export const getHstQuMsgList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETHSTQUMSGLIST_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getHistoryQuestionMessagesList, {
            commit
        },
        data,
        type.GETHSTQUMSGLIST_RECEIVE
    )
};

// 提交用户问题满意度评价
export const submitEvaluate = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SUBMITEVALUATE_REQUEST, data)
        // http 请求
    return ajax.post(
        API.submitEvaluate, {
            commit
        },
        data,
        type.SUBMITEVALUATE_RECEIVE
    )
};

// 提交未登陆用户客服问题
export const saveUnknownQu = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SAVEUNKNOWNQU_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.saveUnknownQu, {
            commit
        },
        data,
        type.SAVEUNKNOWNQU_RECEIVE
    )
};

// 检索 FAQ 内容数据列表
export const searchFaq = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SEARCHFAQ_REQUEST, data)
        // http 请求
    return ajax.get(
        API.searchFaq, {
            commit
        },
        data,
        type.SEARCHFAQ_RECEIVE
    )
};

// 提交举报作弊信息
export const report = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.REPORT_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.report, {
            commit
        },
        data,
        type.REPORT_RECEIVE
    )
};

// 修改 FAQ 未读消息状态
export const updateMsgStatus = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.UPDATEMSGSTATUS_REQUEST, data)
        // http 请求
    return ajax.post(
        API.updateMsgStatus, {
            commit
        },
        data,
        type.UPDATEMSGSTATUS_RECEIVE
    )
};

// 查询客服系统使用版本
export const getFaqVersion = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETFAQVERSION_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getFaqVersion, {
            commit
        },
        data,
        type.GETFAQVERSION_RECEIVE
    )
};